// ----------------------------------------------------------------------------
// Сохранение данных пользователя
// ----------------------------------------------------------------------------



import { isVisible, isHidden } from "../check/checkVisibility.js";
import {removeElements} from "../auth-common/auth-misc-functions.js";
import {accountElements, authElements} from "../auth-common/auth-account-elements.js";



const ttLKSave = (e) => {
    e?.preventDefault();

    const formEl = e.currentTarget.closest('form'); // Получаем саму форму, на которую повешен слушатель
    const confirmEl = document.getElementById('js-myaccount-form-resume__confirm');

    if (
        isHidden(confirmEl) &&
        authElements.ttAuthName &&
        authElements.ttAuthName.getAttribute('name') === 'name' &&
        !authElements.ttAuthName.readOnly
    ) {
        const resumeConfirmName = document.getElementById('js-myaccount-form-resume__confirm-name');
        if (resumeConfirmName && authElements.ttAuthName) {
            resumeConfirmName.textContent = authElements.ttAuthName.value;
        }

        const button = document.getElementById('js-myaccount-form-resume__btn');
        if (button) button.style.display = 'none';

        document.querySelectorAll('.js-myaccount-form-resume__confirm')
            .forEach(el => el.style.display = '');

    } else {
        if (isVisible(confirmEl)) {
            document.querySelectorAll('.ttAuth_btn_confirm-block')
                .forEach(block => block.disabled = true);
        }
        removeElements('.g-message');

        if (formEl.checkValidity()) {
            if (authElements.ttAuthBtn) authElements.ttAuthBtn.disabled = true;

            accountElements.accountHeader?.insertAdjacentHTML('afterend', '<div class="g-message">Обработка данных...</div>');
            formEl.submit();
        } else {
            formEl.reportValidity();
        }
    }
}

export default ttLKSave;